import { render, staticRenderFns } from "./task-toolbar.vue?vue&type=template&id=1abd1480&"
import script from "./task-toolbar.vue?vue&type=script&lang=ts&"
export * from "./task-toolbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports